import { axiosInstance } from '.'
import {
  GET_ADMIN_OPPORTUNITY_QUESTIONS,
  GET_ADMIN_OPPORTUNITY_QUESTION,
  REPLY_ADMIN_OPPORTUNITY_QUESTION,
} from './endpoints'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'

export type OpportunityQuestionStatus = 'pending' | 'answered'

export interface AdminOpportunityQuestion {
  id: number
  opportunity_id: number
  asked_by_investor_id: number
  question_text: string
  status: OpportunityQuestionStatus
  answer_text: string | null
  answered_at: string | null
  answered_by_admin_id: number | null
  opportunity_title: string | null
  asker_name: string | null
  asker_email: string | null
  created_at: string
  updated_at: string
}

export interface AdminOpportunityQuestionListParams {
  page?: number
  limit?: number
  opportunity_id?: number | string
  status?: OpportunityQuestionStatus
}

export interface PaginationMeta {
  total: number
  limit: number
  page: number
  offset: number
  count: number
}

export interface AdminOpportunityQuestionListResponse {
  questions: AdminOpportunityQuestion[]
  pagination: PaginationMeta
  status: number
}

export type GetAdminOpportunityQuestionResult =
  | { question: AdminOpportunityQuestion; status: number }
  | { status: number }

export const opportunityQuestionsServices = {
  getQuestion: async (id: number | string): Promise<GetAdminOpportunityQuestionResult> => {
    try {
      const response = await axiosInstance.get(GET_ADMIN_OPPORTUNITY_QUESTION(id))
      return {
        question: response.data as AdminOpportunityQuestion,
        status: response.status,
      }
    } catch (error: unknown) {
      const err = error as { response?: { status: number } }
      return { status: err.response?.status ?? 0 }
    }
  },

  listQuestions: async (
    params: AdminOpportunityQuestionListParams,
  ): Promise<AdminOpportunityQuestionListResponse> => {
    try {
      const response = await axiosInstance.get(GET_ADMIN_OPPORTUNITY_QUESTIONS, {
        params: removeEmptyValueFromObject(params),
      })
      const limit = Number(response.data?.limit || 0)
      const page = Number(response.data?.page || 1)
      const total = Number(response.data?.total || 0)

      return {
        questions: response.data?.questions || [],
        pagination: {
          total,
          limit,
          page,
          offset: page > 0 && limit > 0 ? (page - 1) * limit : 0,
          count: total,
        },
        status: response.status,
      }
    } catch (error: any) {
      return error.response
    }
  },

  replyToQuestion: async (id: number | string, answer: string) => {
    try {
      return await axiosInstance.patch(REPLY_ADMIN_OPPORTUNITY_QUESTION(id), { answer })
    } catch (error: any) {
      return error.response
    }
  },
}
